import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FormService } from '../../../common/services/form.service';
import { Field } from 'src/sb-tools/typescript/models/field.model';
import { ClientField } from '../../../common/models/client-field.model';
import { TranslateModule } from '@ngx-translate/core';
import { FocusDirective } from '@sb-tools/typescript/directives/focus.directive';
import { IntlTelInputDirective } from '@sb-tools/typescript/directives/intl-tel-input-directive';
import { NgClass } from '@angular/common';
import { FormFieldLabelComponent } from '@form-field-module/common/components/form-field-label/form-field-label.component';
import { LocalizationLanguage } from '@sb-tools/typescript/enums/localization-language.enum';

@Component({
    selector: 'sb-mobile-number',
    templateUrl: './mobile-number.component.html',
    styleUrls: ['./mobile-number.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    imports: [TranslateModule, FormsModule, FocusDirective, IntlTelInputDirective, NgClass, FormFieldLabelComponent],
})
export class MobileNumberComponent implements OnInit {
    @Input() formField: Field | ClientField;
    @Input() language: LocalizationLanguage;

    @ViewChild('field') field: any;

    cellInputConfig: {
        [key: string]: string | number | boolean;
    };

    placeholder: string;

    constructor(public formService: FormService) {}

    ngOnInit(): void {
        this.cellInputConfig = {
            nationalMode: true,
            separateDialCode: false,
            autoHideDialCode: true,
        };
        switch (this.language) {
            case LocalizationLanguage.norwegian: {
                this.cellInputConfig.initialCountry = 'no';
                break;
            }
            case LocalizationLanguage.swedish: {
                this.cellInputConfig.initialCountry = 'se';
                break;
            }
            case LocalizationLanguage.danish: {
                this.cellInputConfig.initialCountry = 'dk';
                break;
            }
            case LocalizationLanguage.finnish: {
                this.cellInputConfig.initialCountry = 'fi';
                break;
            }
        }
    }

    hasError(event: boolean): void {
        if (!event && this.field.control.value !== '' && this.field.control.value !== null) {
            this.field.control.setErrors(['invalid_cell_phone', true]);
        }
    }

    setNationalNumber(value: string): void {
        this.field.control.setValue(value);
    }

    validatePhonePattern(event: KeyboardEvent): boolean {
        const pattern = /^[+]*([0-9])*$/;
        return pattern.test(event.key);
    }
}
